/**
 * @generated SignedSource<<b3a9b66bcf1bee3ff7599f72a20912ec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfilePicture_picture$data = {
  readonly url: string | null | undefined;
  readonly " $fragmentType": "ProfilePicture_picture";
};
export type ProfilePicture_picture$key = {
  readonly " $data"?: ProfilePicture_picture$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfilePicture_picture">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfilePicture_picture",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    }
  ],
  "type": "ProfilePicture",
  "abstractKey": null
};

(node as any).hash = "072c93f9484c84ef9d8b536f4a04d999";

export default node;
